const vinculos = {
    produtor: "Produtor",
    equipamento: "Equipamento",
    setor: "Setor",
    funcionario: "Funcionário",
    ponto_coleta : "Pontos de Coleta"
}

export { vinculos };